function aboutTimelineSlider() {
  [...document.querySelectorAll('.about-testimonials')]?.forEach( slider => {
    new Splide( slider, {
      speed: 1000,
      perPage: 1,
      perMove: 1,
      gap: '1.5rem',
      autoHeight: true,
      lazyload: 'sequential',
    } ).mount();
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  aboutTimelineSlider();
} );